import { useState, useEffect, useRef } from 'react'
import { Play, Pause, Square, RotateCcw } from 'lucide-react'
import Card from '../components/Card'
import Button from '../components/Button'

export default function Stopwatch() {
  const [time, setTime] = useState(0)
  const [isRunning, setIsRunning] = useState(false)
  const [laps, setLaps] = useState([])
  const intervalRef = useRef(null)

  useEffect(() => {
    if (isRunning) {
      intervalRef.current = setInterval(() => {
        setTime((prev) => prev + 10)
      }, 10)
    } else {
      clearInterval(intervalRef.current)
    }

    return () => clearInterval(intervalRef.current)
  }, [isRunning])

  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000)
    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60
    const centiseconds = Math.floor((milliseconds % 1000) / 10)
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}.${String(centiseconds).padStart(2, '0')}`
  }

  const startStop = () => {
    setIsRunning(!isRunning)
  }

  const reset = () => {
    setTime(0)
    setIsRunning(false)
    setLaps([])
  }

  const lap = () => {
    if (isRunning) {
      setLaps([...laps, time])
    }
  }

  return (
    <div className="space-y-6">
      <Card>
        <Card.Body>
          <div className="text-center mb-6">
            <div className="text-6xl font-bold text-primary-600 mb-4 font-mono">
              {formatTime(time)}
            </div>
          </div>

          <div className="flex gap-4 justify-center mb-6">
            <Button onClick={startStop} variant={isRunning ? 'secondary' : 'primary'}>
              {isRunning ? (
                <>
                  <Pause className="w-4 h-4 mr-2" />
                  Pause
                </>
              ) : (
                <>
                  <Play className="w-4 h-4 mr-2" />
                  Start
                </>
              )}
            </Button>
            <Button onClick={lap} variant="outline" disabled={!isRunning}>
              <RotateCcw className="w-4 h-4 mr-2" />
              Lap
            </Button>
            <Button onClick={reset} variant="outline">
              <Square className="w-4 h-4 mr-2" />
              Reset
            </Button>
          </div>

          {laps.length > 0 && (
            <div className="mt-6">
              <h3 className="text-lg font-semibold mb-3">Laps:</h3>
              <div className="space-y-2 max-h-64 overflow-y-auto">
                {laps.map((lapTime, index) => (
                  <div key={index} className="flex justify-between items-center p-2 bg-gray-50 rounded">
                    <span className="font-medium">Lap {laps.length - index}</span>
                    <span className="font-mono">{formatTime(lapTime)}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  )
}

